import { createSlice } from '@reduxjs/toolkit';
import * as Data from './prepayment-calculator-data';

// Initial state
const initialState = {
    loans: Data.defaultLoansData,
    selectedStrategy: 'Pay loans with highest AIPR (Recommended)',
    bonusAmount: '500000',
};

// Create a slice
const prepaymentCalculatorSlice = createSlice({
    name: 'prepayment',
    initialState,
    reducers: {
        setLoans: (state, action) => {
            state.loans = action.payload;
        },
        setSelectedStrategy: (state, action) => {
            state.selectedStrategy = action.payload;
        },
        setBonusAmount: (state, action) => {
            state.bonusAmount = action.payload;
        },
    },
});

// Export actions
export const { setLoans, setSelectedStrategy, setBonusAmount } = prepaymentCalculatorSlice.actions;

// Export reducer
export default prepaymentCalculatorSlice.reducer;
